function initGTM() {
  const script = document.createElement('script');
  script.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','w3gtm','GTM-PTK48R8');
`;
  document.head.appendChild(script);
}

declare const window: any;

initGTM();

export const emitEvent = (event: any) => {
  try {
    if (!window.w3gtm) {
      initGTM();
      setTimeout(() => window.w3gtm.push(event), 500);
    } else {
      window.w3gtm.push(event);
    }
  } catch (err) {
    console.warn(err);
  }
};
